import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

export const LAST_CREATED_CAMPAIGN_GROUP_ID = 'lastCreatedCampaignGroupId';

export const useLastCreatedCampaignGroupId = queryParamHookFactory(LAST_CREATED_CAMPAIGN_GROUP_ID);
